import React from "react";

const NotificationComponent = () => {
    return (
        <div className="bg-blue-50 border border-blue-200 text-blue-700 p-4 rounded text-center">
            Real-time notifications will appear here.
        </div>
    );
};

export default NotificationComponent;